var map = {
	"./0.jpg": "00fe",
	"./1.jpg": "425a",
	"./2.jpg": "7e04",
	"./3.jpg": "7b0a",
	"./4.jpg": "47e3",
	"./5.jpg": "b326"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dd66";